module.exports = __webpack_public_path__ + "img/6.85ed6f9f.png";